var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9997 14.83C16.6097 15.2177 15.9797 15.2177 15.5897 14.83L11.9997 11.29L8.4597 14.83C8.06967 15.2177 7.43974 15.2177 7.0497 14.83C6.86039 14.6422 6.75391 14.3866 6.75391 14.12C6.75391 13.8534 6.86039 13.5978 7.0497 13.41L11.2897 9.17C11.4775 8.98068 11.7331 8.8742 11.9997 8.8742C12.2663 8.8742 12.5219 8.98068 12.7097 9.17L16.9997 13.41C17.189 13.5978 17.2955 13.8534 17.2955 14.12C17.2955 14.3866 17.189 14.6422 16.9997 14.83Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default ForwardRef;